import { render, staticRenderFns } from "./ManageCustomers.vue?vue&type=template&id=94575a82&scoped=true"
import script from "./ManageCustomers.vue?vue&type=script&lang=js"
export * from "./ManageCustomers.vue?vue&type=script&lang=js"
import style0 from "./ManageCustomers.vue?vue&type=style&index=0&id=94575a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94575a82",
  null
  
)

export default component.exports